export type TypographyArgs = {
  children: React.ReactNode
  className: string
}

const args = {
  children: 'The quick brown fox jumps over the lazy dog',
  className: '',
}

export { args as default }
